import api from '../index'

export type countriesListType = Array<{
  label: string
  value: string
}>
export default {
  // 获取国家列表
  countries: () => api.get<countriesListType>('member-api/countries'),

  // 后端获取路由数据
  routeList: () => api.get('app/route/list', {
    baseURL: '/mock/',
  }),

  // 基于文件系统路由模式下，后端获取导航菜单数据
  menuList: () => api.get('app/menu/list', {
    baseURL: '/mock/',
  }),
}
